export const adminRoute = (route) => route.replace("/admin", "");
